/*
 * Customer request forms (snippets/ams-quote-form, snippets/ams-stock-alert).
 * - Keeps "Anunță-mă când revine în stoc" in sync with the selected variant.
 * - After a successful post, brings the confirmation into view.
 */
(function () {
  function syncStockAlert(alert, variant) {
    if (!variant) {
      alert.hidden = true;
      return;
    }
    if (alert.querySelector('[data-ams-stock-posted]')) return;
    alert.hidden = !!variant.available;

    var title = variant.title === 'Default Title' ? '' : variant.title;
    var fields = {
      variant: title || '',
      sku: variant.sku || ''
    };
    Object.keys(fields).forEach(function (key) {
      var input = alert.querySelector('[data-ams-field="' + key + '"]');
      if (input) input.value = fields[key];
    });
    var url = alert.querySelector('[data-ams-field="url"]');
    if (url) url.value = url.getAttribute('data-base') + '?variant=' + variant.id;
  }

  function init() {
    var alerts = document.querySelectorAll('[data-ams-stock-alert]');
    Array.prototype.forEach.call(alerts, function (alert) {
      if (alert.querySelector('[data-ams-stock-posted]')) alert.hidden = false;

      var section = alert.closest('[data-section-type="product"]');
      if (section && window.jQuery) {
        window.jQuery(section).on('variantChange', function (evt) {
          syncStockAlert(alert, evt.variant);
        });
      }
    });

    // "Cumpără de pe SEAP": product code follows the selected variant.
    Array.prototype.forEach.call(document.querySelectorAll('[data-ams-seap-sku]'), function (el) {
      var section = el.closest('[data-section-type="product"]');
      var row = el.closest('[data-ams-seap-sku-row]');
      if (!section || !window.jQuery) return;
      window.jQuery(section).on('variantChange', function (evt) {
        var sku = evt.variant && evt.variant.sku ? evt.variant.sku : '';
        el.textContent = sku;
        if (row) row.hidden = !sku;
      });
    });

    // ?produs=… from search links pre-fills "Ce produs cauți?"
    var params = window.URLSearchParams ? new URLSearchParams(window.location.search) : null;
    Array.prototype.forEach.call(document.querySelectorAll('[data-ams-prefill]'), function (input) {
      var value = params && params.get(input.getAttribute('data-ams-prefill'));
      if (value && !input.value) input.value = value.slice(0, 200);
    });

    var success = document.querySelector('[data-ams-focus]');
    if (success && /contact_posted=true/.test(window.location.search)) {
      success.scrollIntoView({ block: 'center' });
      success.focus({ preventScroll: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
